module.exports = __webpack_public_path__ + "static/high_country_sporting_goods-6e0998b5482068ac202719449ec30cfb.jpg";